import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import BottomTabs from '../components/BottomTabs';
import { useNavigate } from 'react-router-dom';

const MainLayout = ({ bookmarkCount }) => {
  const navigate = useNavigate();
  const location = useLocation();
  
  const getActiveTab = () => {
    const path = location.pathname;
    if (path === '/') return 'home';
    if (path === '/history') return 'history';
    if (path === '/bookmarks') return 'bookmarks';
    if (path === '/explore') return 'categories';
    return 'home';
  };

  const handleTabChange = (tabId) => {
    if (tabId === 'home') navigate('/');
    else if (tabId === 'history') navigate('/history');
    else if (tabId === 'bookmarks') navigate('/bookmarks');
    else if (tabId === 'categories') navigate('/explore');
  };

  return (
    <div className="min-h-screen bg-white py-10 px-4 sm:px-6 selection:bg-indigo-100 pb-32">
      <div className="max-w-md mx-auto relative w-full overflow-x-hidden">
        <Header />
        <main>
          <Outlet />
        </main>
        <Footer />
      </div>
      <BottomTabs 
        activeTab={getActiveTab()} 
        onTabChange={handleTabChange} 
        bookmarkCount={bookmarkCount} 
      />
    </div>
  );
};

export default MainLayout;